module.exports = __webpack_public_path__ + "static/media/web-scrapper.69ce2d74.png";